import instacart from 'legacy/common/instacart'
import { errors } from 'utils/error-handling/errors'

interface SaveForRetailerProductIdsProps extends BaseProps {
  /**
   * An array of product IDs which will be updated.
   */
  productIds: number[]
}

interface SaveForSearchParamsProps extends BaseProps {
  /**
   * The term used to search for the products.
   */
  searchTerm: string

  /**
   * The type of search used. Eg: "Name" / "SKU" / "RRC"
   */
  searchType: string
}

interface BaseProps {
  /**
   * The partner which owns these products.
   */
  partnerId: string

  /**
   * The warehouse under the partner behind affected.
   */
  warehouseId: number

  /**
   * The new aisle that the products are being set to.
   */
  selectedAisleId: string

  /**
   * The code for the locale. Eg: "EN_US"
   */
  localeCode: string

  /**
   * Notified when the execution has finished, regardless of the outcome.
   */
  onFinish?: () => void

  /**
   * Notified when the execution has finished with a successful result.
   */
  onSuccess?: () => void

  /**
   * Notified when the execution has finished with a failure result.
   */
  onFailure?: (e: any) => void
}

const saveDepartmentAisleBase = (
  payload: {},
  { partnerId, warehouseId, selectedAisleId, localeCode, onFinish, onSuccess, onFailure }: BaseProps
) => {
  instacart.go
    .put(`/v1/partners/${partnerId}/warehouses/${warehouseId}/products/bulk_set_main_aisle`, {
      data: {
        ...payload,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        to_aisle_id: parseInt(selectedAisleId),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        locale_code: localeCode?.toUpperCase(),
      },
    })
    .then(() => {
      if (onFinish) onFinish()
      if (onSuccess) onSuccess()
    })
    .catch(e => {
      if (onFinish) onFinish()
      if (onFailure) onFailure(e)

      errors.captureException(e)
    })
}

/**
 * For when you want to update the Department and Aisles for a specific set of
 * Retailer Product IDs.
 *
 * @param input args -- see Props
 */
export const saveDepartmentAisleForRetailerProductIds = ({
  productIds,
  ...rest
}: SaveForRetailerProductIdsProps) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const payload = { product_ids: productIds }
  saveDepartmentAisleBase(payload, rest)
}

/**
 * For when you want to update the Department and Aisles for a specific search.
 *
 * @param input args -- see Props
 */
export const saveDepartmentAisleForQueryParams = ({
  searchTerm,
  searchType,
  ...rest
}: SaveForSearchParamsProps) => {
  const payload = { term: searchTerm, searchType: searchType }
  saveDepartmentAisleBase(payload, rest)
}
